import { render, staticRenderFns } from "./BurglaryComponent.vue?vue&type=template&id=60f25c76&scoped=true&"
import script from "./BurglaryComponent.vue?vue&type=script&lang=js&"
export * from "./BurglaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f25c76",
  null
  
)

export default component.exports